/**
 * AllergenDeclarationAction - synchronized with the Prisma enum of the same
 * name. Recorded on every `IngredientAllergenHistory` row: DECLARED for a new
 * or changed declaration, REMOVED for a retraction. The removal is the
 * dangerous edit and must be provable, hence the append-only history.
 */
export const ALLERGEN_DECLARATION_ACTIONS = ['DECLARED', 'REMOVED'] as const;
export type AllergenDeclarationAction = (typeof ALLERGEN_DECLARATION_ACTIONS)[number];
